/* bb-faq.js -- layout `colunas` do faq-bb: iguala, linha a linha, a altura das perguntas das
   duas colunas acima de 768px. Porte do equalizeFaqHeights() do faq-dinamico
   (faq-dinamico.liquid:404-439), com os mesmos gatilhos: 150ms depois do DOMContentLoaded e a
   cada resize. Abrir uma pergunta não chama nada, como no live: a coluna vizinha não se mexe.
   Uma grade CSS igualaria sem JS, mas amarra as linhas: abrir a 1a pergunta empurrava a coluna
   da direita 151-194px (medido na correção 1 da L6 T3, a 800 e 1024px). */
(() => {
  const igualar = () => {
    for (const lista of document.querySelectorAll('.bb-faq--colunas .bb-faq__lista')) {
      const perguntas = lista.querySelectorAll('.bb-faq__pergunta');
      if (window.innerWidth <= 768) {
        perguntas.forEach((q) => (q.style.minHeight = 'auto'));
        continue;
      }
      const [esq, dir] = [...lista.children].map((coluna) => coluna.querySelectorAll('.bb-faq__pergunta'));
      esq.forEach((e, i) => {
        const d = dir && dir[i];
        e.style.minHeight = 'auto';
        if (!d) return;
        d.style.minHeight = 'auto';
        const altura = Math.max(e.getBoundingClientRect().height, d.getBoundingClientRect().height);
        e.style.minHeight = d.style.minHeight = altura + 'px';
      });
    }
  };
  document.addEventListener('DOMContentLoaded', () => setTimeout(igualar, 150));
  window.addEventListener('resize', igualar);
})();
